import React, { useCallback, useState } from "react";
import { DataLake } from "@graylog/enterprise-api";
import { Modal } from "components/bootstrap";
import { Pluralize, ModalSubmit } from "components/common";
import RetrievalHelp from "data-lake/RetrievalHelp";
import UserNotification from "util/UserNotification";
import useSelectableLogViewMessages from "logview/components/contexts/useSelectableLogViewMessages";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import useRetrieval from "data-lake/preview/hooks/useRetrieval";
import useSelectedMessageEntities from "views/hooks/useSelectedMessageEntities";
const BulkRetrievalModal = ({ onCancel, retrievalPayload }) => {
  const { isEntitySelected, selectedEntities } = useSelectedMessageEntities();
  const { selectableLogViewMessages } = useSelectableLogViewMessages();
  const { selectedDataLake } = useSelectedDataLake();
  const { bulkRetrievePayload } = useRetrieval();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const onSubmit = useCallback(() => {
    const selectedMessages = selectableLogViewMessages.filter(({ id, index }) => isEntitySelected(index, id)).map(({ id, timestamp }) => ({ id, timestamp }));
    setIsSubmitting(true);
    DataLake.retrieveMultipleMessages(bulkRetrievePayload(selectedMessages, selectedDataLake.id, retrievalPayload)).then(() => {
      UserNotification.success("Data Lake messages retrieval operation launched successfully.", "Success");
      onCancel();
    }).catch((error) => {
      UserNotification.error(`An error occurred while retrieving data. ${error}`);
    }).finally(() => {
      setIsSubmitting(false);
    });
  }, [
    selectableLogViewMessages,
    bulkRetrievePayload,
    selectedDataLake.id,
    retrievalPayload,
    isEntitySelected,
    onCancel
  ]);
  return /* @__PURE__ */ React.createElement(Modal, { show: true, onHide: onCancel }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, "Retrieving from Data Lake")), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement("p", null, "You are about to retrieve ", selectedEntities == null ? void 0 : selectedEntities.length, " ", /* @__PURE__ */ React.createElement(Pluralize, { singular: "log", plural: "logs", value: selectedEntities == null ? void 0 : selectedEntities.length }), "."), /* @__PURE__ */ React.createElement(RetrievalHelp, null)), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      onCancel,
      submitButtonText: "Retrieve",
      isSubmitting,
      submitLoadingText: "Retrieving...",
      onSubmit,
      isAsyncSubmit: true
    }
  )));
};
export default BulkRetrievalModal;
